import { Link } from "react-router-dom";
import Bazr from "../../assets/images/imgfarmer/images.png";
import seed from "../../assets/images/imgfarmer/seed.png";
import payment from "../../assets/images/imgfarmer/paymentFarmer.png";
import bar from "../../assets/images/imgfarmer/bar.png";
import plased from "../../assets/images/imgfarmer/plased.png";
import zemant from "../../assets/images/imgfarmer/zemant.png";
import resivewast from "../../assets/images/imgfarmer/Screenshot+2025-07-28+182123_263773.jpg";
import suger from "../../assets/images/imgfarmer/suger.jpg";
import BreadCrumb from "Common/BreadCrumb";

interface ImageItem {
  id: number;
  title: string;
  link: string;
  defaultImage: string;
}

const images: ImageItem[] = [
  {
    id: 1,
    title: "قرارداد کشاورزان",
    link: "/Commitment",
    defaultImage: plased,
  },
  {
    id: 332,
    title: "بذر کشاورزان",
    link: "/register/seedFarmer",
    defaultImage: Bazr,
  },
  { id: 2, title: "سم کشاورزان", link: "/PoisonDelivery", defaultImage: seed },
  {
    id: 4,
    title: "پرداختی کشاورزان",
    link: "/paymentFarmer2",
    defaultImage: payment,
  },
  {
    id: 3,
    title: "ضمانت کشاورزان",
    link: "/Guarantee2",
    defaultImage: zemant,
  },
  {
    id: 32,
    title: "بار کشاورزان",
    link: "/Burden_of_farmers",
    defaultImage: bar,
  },
  {
    id: 322,
    title: "تحویل شکر",
    link: "/resive_sugar",
    defaultImage: suger,
  },
  {
    id: 3253,
    title: "تحویل تفاله",
    link: "/resive_wast",
    defaultImage: resivewast,
  },
];

const PlacedFarmer: React.FC = () => {
  return (
    <>
      <BreadCrumb pageTitle="هاویر کشت" title="عملیات کشاورز" />
      <div className="p-1 mb-2 mt-[2rem] overflow-auto">
        <div className="title-feature overflow-auto w-[70%] mx-auto flex items-center justify-center gap-2">
          <div className="line h-[3px] overflow-auto bg-gradient-to-r from-transparent via-[#8fb9c0] to-transparent shadow-md flex-1 sm:block hidden"></div>
          <h3 className="dark:text-white text-black whitespace-nowrap font-bold pb-4 pt-1 text-2xl">
            عملیات
          </h3>
          <div className="line h-[3px] bg-gradient-to-r from-transparent via-[#426368] to-transparent shadow-md flex-1 sm:block hidden"></div>
        </div>

        <div className="grid mt-3 justify-center overflow-auto items-center grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((img) => (
            <div
              key={img.id}
              className="relative group rounded-lg overflow-auto shadow-lg border border-gray-300 dark:border-gray-700 transition-transform transform hover:scale-105"
            >
              <Link to={img.link} className="block">
                <div
                  className="w-full h-40 bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${img.defaultImage})`,
                  }}
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center text-white text-2xl font-semibold p-2">
                  {img.title}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PlacedFarmer;
